<template>
	<div class="single-mapping flex-space-between--center">
		<div class="flex-3 flex-start--center mapping-option height-100 bordered-box disabled-box disabled">
			<slot />
		</div>
		<div class="flex-1 flex-centerize">
			<DoubleArrowSvg class="flex-1" :class="{ 'ml-4': !disabled }" />
			<SIconServices v-if="!disabled" :name="serviceSlug" class="mx-4" :width="20" :height="20" />
		</div>
		<div class="flex-3 flex-centerize">
			<v-autocomplete
				dense
				outlined
				clearable
				hide-details
				:value="value"
				:items="items"
				v-if="!disabled"
				item-text="option"
				item-value="value"
				placeholder="Choose a field"
				class="auto-complete-container"
				@change="(item) => onChange(item)"
			/>
			<AppSelect
				v-else
				small
				dense
				naked
				:value="value"
				:items="items"
				item-text="option"
				item-value="value"
				:disabled="disabled"
				placeholder="Choose a field"
				@change="(item) => onChange(item)"
				class="flex-1 mapping-option bordered-box"
			/>
			<AppCloseX v-if="enableDelete" class="ml-2" @onClose="$emit('onClose', source)" />
		</div>
	</div>
</template>

<script>
import SIconServices from '@/components/SIconServices';
import DoubleArrowSvg from './assets/DoubleArrowSvg';

export default {
	name: 'SingleMapping',
	components: { DoubleArrowSvg, SIconServices },
	props: {
		source: { type: String },
		value: { type: String },
		items: { type: Array },
		serviceSlug: { type: String },
		enableDelete: { type: Boolean },
		disabled: { type: Boolean, default: false },
	},
	methods: {
		onChange(src, item) {
			const destination = Array.isArray(item) ? undefined : item;
			this.$emit('onSingleMappingChanged', src, destination);
		},
	},
};
</script>

<style lang="scss" scoped>
.single-mapping {
	.mapping-option {
		&.disabled {
			cursor: not-allowed;
		}
		height: 40px;
	}
	.flex-2,
	::v-deep(.app-select) {
		overflow: hidden;
	}
}

.auto-complete-container {
	&::v-deep {
		&.v-input {
			font-size: 14px;
			border-radius: 7px;
			&.disabled {
				opacity: 0.5;
			}
		}
		&.v-input__slot {
			border: 0px solid transparent !important;
		}
		.v-input__icon i {
			font-size: 18px;
			margin-left: 6px;
			transform: translate(-2px, -2px);
		}
		.v-input__append-inner {
			margin-right: -8px;
		}
	}
}
</style>
